import styles from "./FooterMenuList.module.css";
import { Link } from "react-router-dom";

/**
 * @author yjkim
 * @date 2022-09-21 13:28
 * @remark 헤더 메뉴의 메뉴 리스트
 * @param FooterMenuListProps
 *       text (string) : 표시되는 텍스트
 *       link (string) : 클릭시 연결되는 url
 * @returns FooterMenuList JSX.Element 
 */

export interface FooterMenuListProps {
    text: string
    link: string
}

export function FooterMenuList(props: any) {
    return (
        <li>
            <Link to={props.link} className={styles.footerATag}>{props.text}</Link>
        </li>
    )
}
